import { makeStyles } from '@material-ui/core/styles';

import globalTheme from '../globalTheme';

const useStyles = makeStyles(theme => ({
  commentDetails: {
    backgroundColor: globalTheme.palette.neutral.lightAlpha,
    borderRadius: '4px',
    display: 'flex',
    flexDirection: 'column',
    margin: '8px auto',
    '& p': {
      margin: '0.75em'
    },
    '& .MuiInput-underline:before': {
      border: 'none'
    },
    '& .MuiInput-underline:hover:not(.Mui-disabled):before': {
      borderBottom: 'none'
    },
    '& .MuiInput-underline:after': {
      borderColor: globalTheme.palette.secondary.main
    },
    '& .MuiInputBase-input.Mui-disabled': {
      color: globalTheme.palette.neutral.medDark
    }
  },
  commentInfoContain: {
    display: 'flex'
  },
  textFieldContainer: {
    width: '95%',
    margin: '0.5em 1em'
  },
  textField: {
    width: '100%'
  },
  disabled: {
    backgroundColor: globalTheme.palette.neutral.light,
    borderRadius: '4px',

    '& .MuiFormLabel-root.Mui-disabled': {
      color: globalTheme.palette.neutral.medLight,
      [theme.breakpoints.down('sm')]: {
        textTransform: 'none'
      }
    }
  },
  enterComment: {
    '& .MuiOutlinedInput-root fieldset': {
      border: `.5px solid ${globalTheme.palette.neutral.light}`
    }
  },
  editable: {
    '& p': {
      fontStyle: 'normal',
      [theme.breakpoints.down('sm')]: {
        textTransform: 'none'
      }
    },
    backgroundColor: globalTheme.palette.neutral.contrast,
    border: `1.5px solid ${globalTheme.palette.neutral.light}`
  },
  closedStatus: {
    display: 'none'
  },
  checkBoxContainer: {
    display: 'flex',
    justifyContent: 'flex-end',
    color: globalTheme.palette.primary.main
  },
  uncheckedContainer: {
    display: 'flex',
    justifyContent: 'flex-end',
    color: globalTheme.palette.neutral.medDark
  },
  checkBox: {
    '&.Mui-checked ': {
      color: globalTheme.palette.primary.main
    }
  }
}));

export default useStyles;
